const RATOEIRA_HIDDEN_FROM_CLIENTE_ID = 13900;

export function canSeeRatoeira(clienteId: unknown): boolean {
    const id = Number(String(clienteId ?? '').trim());
    if (!Number.isInteger(id) || id <= 0) {
        return false;
    }

    return id < RATOEIRA_HIDDEN_FROM_CLIENTE_ID;
}
